import { GrnItemIdRequest } from "@gtpl/shared-models/procurement-management";
import { Button, Card, Input, Table } from "antd";
import { CaretRightOutlined, SearchOutlined, FilterOutlined, EditOutlined, SplitCellsOutlined, CheckCircleTwoTone, CloseOutlined, RotateRightOutlined, RedoOutlined, DoubleLeftOutlined, PrinterOutlined } from '@ant-design/icons'
import Highlighter from 'react-highlight-words';

import React, { useEffect, useRef, useState } from "react";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { ColumnProps } from "antd/lib/table";
import { GrnService } from "@gtpl/shared-services/procurement";
import moment from "moment";

// const { Column } = Table;

export interface GrnInspectionProps{
  grnItemId:number
}

const GrnInspectionGrid = (props:GrnInspectionProps) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const gnrservice = new GrnService();
    const [page, setPage] = React.useState(1);
    const [inspectionReasons, setinspectionReasons] = useState<any[]>([])

    // console.log(props.grnItemId,'---')

useEffect(()=>{
    getInspectionReasonsData(props.grnItemId)

  },[props.grnItemId])

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),



    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      console.log(searchInput.current);
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },



    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });



  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const getInspectionReasonsData = (val) => {
    console.log('okkk')
    const req = new GrnItemIdRequest(val)

    gnrservice.getStatusDetails(req).then(res => {
      if (res.status) {
        setinspectionReasons(res.data);
        return (
          <Table 
          columns={inspectionStatusDetails} 
          dataSource={res.data} 
          pagination={false} size='small'/>
        )
      } else {
        setinspectionReasons([])
        AlertMessages.getErrorMessage(res.internalMessage);

      }
    })
  };

  const inspectionStatusDetails: ColumnProps<any>[] = [
    {
      title: 'Status',
      dataIndex: 'status',
      width: 130,
      align: 'left',
    //   ...getColumnSearchProps('status'),
    //   sorter: (a, b) => a.status.localeCompare(b.status),
    //   sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      width: 130,
      align: 'left',
    //   ...getColumnSearchProps('quantity'),
    //   sorter: (a, b) => a.quantity.localeCompare(b.quantity),
    //   sortDirections: ['descend', 'ascend'],
    },
    {
      title: ' Reason',
      dataIndex: 'reason',
      width: 130,
      align: 'left',
      render: (text: any, record: any) => { return record.reason? record.reason : '-' } ,
    //   ...getColumnSearchProps('reason'),
    //   sorter: (a, b) => a.reason.localeCompare(b.reason),
    //   sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Inspection Date',
      dataIndex: 'inspectionDate',
      width: 130,
      align: 'left',
      
      render: (text: any, record: any) => { return record.inspectionDate ? moment(record.inspectionDate).format('DD-MM-YYYY') : '-' },
    //   ...getColumnSearchProps('inspectionDate'),
    //   sorter: (a, b) => a.inspectionDate.localeCompare(b.inspectionDate),
    //   sortDirections: ['descend', 'ascend'],
    }
  ]
  return(
    <Card>
        <Table 
        columns={inspectionStatusDetails}
        dataSource={inspectionReasons}
        pagination={false} >
        </Table>
    </Card>

  );

};
  export default GrnInspectionGrid;

